<template>
    <div>
        <div
            aria-hidden="true"
            aria-labelledby="modalFillInLabel"
            class="modal modal-note animation opacity"
            id="modal-chat-templates"
            role="dialog"
            tabindex="-1"
        >
            <div v-show="mode === 'list'" class="modal-dialog modal-lg">
                <div class="modal-content">
                    <header class="modal-header">
                        <div class="has-popover">
                            <span class="modal-title h3">{{ __('Message templates') }}</span>
                            <popover class="popover">
                                <strong slot="header">{{ __('How do the message templates work?') }}</strong>
                                <div class="popover__text" slot="content">
                                    <p v-html="__('For inspiration or to speed up your work, you have the option of using the pre-written patient reports. Clicking on the :icon icon or on the text “select from template“ in the chat text window will open a window where you can select from already created templates or create your own template within the selected category.', { icon: icon } )"></p>

                                    <p v-html="__(`After clicking on <strong class='text-violet-light'>'Move to chat'</strong>, the selected template will be copied to the text window in chat, where you can further edit it as needed before sending.`)"></p>
                                </div>
                            </popover>
                        </div>

                        <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                            <svg-icon icon="close-modal" />
                        </button>
                    </header>
                    <div class="modal-body">
                        <div class="templates-filter">
                            <nav>
                                <ul class="tabs-list">
                                    <li v-for="category in filteredCategories" :key="category.id">
                                        <button
                                            :class="{ active: selectedCategory === category.id }"
                                            type="button"
                                            @click="selectedCategory = category.id"
                                        >
                                            {{ __(category.label) }}
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <div>
                            <VButton :label="__('New template')" @onClick="mode = 'create'" size="sm" position="right" />
                        </div>

                        <div class="templates-list">
                            <div
                                v-for="template in filteredTemplates"
                                :key="template.id"
                                class="template-item template-welcome active"
                            >
                                <header>
                                    <strong class="template-type">{{ __(categoryName(template.category)) }}</strong>
                                    <span v-if="template.user_id" class="template-tag own">{{ __('Custom') }}</span>
                                </header>

                                <div class="template-content">
                                    <p>{{ template.body }}</p>
                                </div>

                                <footer>
                                    <a href="#" @click="addMessage(template)">
                                        {{ __('Move to chat') }}
                                    </a>

                                    <a href="#" v-if="template.user_id" @click.prevent="editTemplate(template)">
                                        <!-- TODO extract svg -->
                                        <svg
                                            aria-hidden="true"
                                            focusable="false"
                                            height="17"
                                            widht="17"
                                            data-prefix="fas"
                                            data-icon="pencil-alt"
                                            class="svg-inline--fa fa-pencil-alt fa-w-16"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                        >
                                            <path
                                                fill="#B9B7C7"
                                                d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                                            ></path>
                                        </svg>
                                        <span>{{ __('Edit template') }}</span>
                                    </a>

                                    <a
                                        v-if="template.user_id"
                                        href="#"
                                        @click.prevent="removeTemplate(template)"
                                    >
                                        <!-- TODO extract svg -->
                                        <svg
                                            aria-hidden="true"
                                            height="17"
                                            width="15"
                                            focusable="false"
                                            data-prefix="fas"
                                            data-icon="trash-alt"
                                            class="svg-inline--fa fa-trash-alt fa-w-14"
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512"
                                        >
                                            <path
                                                fill="#B9B7C7"
                                                d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                                            ></path>
                                        </svg>
                                        <span>{{ __('Delete template') }}</span>
                                    </a>
                                </footer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <chat-templates-create v-if="mode === 'create'" @mode="setMode"></chat-templates-create>
            <chat-templates-edit v-if="mode === 'edit'" :template="template" @mode="setMode"></chat-templates-edit>
        </div>

        <chat-templates-delete v-if="mode === 'delete'" :template="template" @mode="setMode"></chat-templates-delete>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        props: {},
        data() {
            return {
                selectedCategory: null,
                origin: 'window',
                icon: '<svg aria-hidden="true" class="svg-inline--fa fa-align-left fa-w-14" data-icon="align-left" data-prefix="fas" focusable="false" height="12" role="img" viewBox="0 0 448 512" width="12" xmlns="http://www.w3.org/2000/svg"><path d="M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z" fill="#C193FF"></path></svg>',
                mode: 'list',
                template: null,
                categories: [
                    {id: 'welcome', label: 'Introduction', locale: 'cs'},
                    {id: 'praise', label: 'Praise', locale: 'cs'},
                    {id: 'advice', label: 'Advice', locale: 'cs'},
                    {id: 'encouragement', label: 'Encouragement', locale: 'cs'},
                    {id: 'farewell', label: 'Goodbye', locale: 'cs'},
                    {id: 'dashboard', label: 'Vorlagen für Dashboard', locale: 'de'},
                    {id: 'rwe', label: 'RWE-Studie', locale: 'de'},
                    {id: 'support', label: 'Seelische Unterstützung', locale: 'de'},
                    {id: 'communication', label: 'Kommunikation beginnen', locale: 'de'},
                    {id: 'feedback', label: 'Feedback/ Technik', locale: 'de'}
                ]
            }
        },
        computed: {
            ...mapGetters({
                templates: 'chat-templates/templates',
                conversation: 'chat/conversation'
            }),
            recipient() {
                if (this.conversation) {
                    return this.conversation
                }
            },
            filteredTemplates() {
                return this.templates.filter((t) => t.category === this.selectedCategory)
            },
            filteredCategories() {
                return this.categories.filter((cat) => cat.locale === this.templateLocale)
            },
            templateLocale() {
                if(this.user.locale === 'de') {
                    return 'de'
                } else {
                    return 'cs'
                }
            }
        },
        watch: {
            recipient(newRecipient, oldRecipient) {
                if (newRecipient && (!oldRecipient || newRecipient.id !== oldRecipient.id)) {
                    this.fetchTemplates({ recipient: this.recipient.id })
                }
            }
        },
        created() {
            $('#modal-chat-templates').on('shown.bs.modal', (e) => {
                this.fetchTemplates({ recipient: this.recipient.id })
            })
        },
        mounted() {       
            this.selectedCategory = this.user.locale === 'de' ? 'dashboard' : 'welcome' 

            $('#modal-chat-templates').on('shown.bs.modal', (e) => {
                origin = $(e.relatedTarget).data('origin')

                if (origin) {
                    this.origin = origin
                }
            })
        },
        methods: {
            ...mapActions({
                fetchTemplates: 'chat-templates/fetchTemplates'
            }),
            addMessage(template) {
                Vuemit.fire('Chat--input-add-message', {
                    origin: this.origin,
                    template
                })

                $('#modal-chat-templates').modal('hide')
            },
            categoryName(category) {
                let cat = this.categories.find((cat) => cat.id === category)

                return cat.label
            },
            setMode(mode) {
                this.mode = mode
            },
            editTemplate(template) {
                this.mode = 'edit'
                this.template = template
            },
            removeTemplate(template) {
                this.mode = 'delete'
                this.template = template
            }
        }
    }
</script>
